// src/components/Athlete.js
import React, { useState, useEffect } from 'react';
import { TextField, Button, Typography } from '@mui/material';
import { setDNS, getRaceDetails } from './api'; 

const Utilities = () => {
    const [status, setStatus] = useState('')
    const [races, setRaces] = useState([]);


    // Load devices on first load only
    useEffect(() => {firstLoad();},[])

    const firstLoad = () => {
        getRaceDetails().then((val) => {
            setRaces(val.Races)
        })
    }

    const submitDNS = (bibs) => {
        setDNS(bibs).then((val) => { 
            setStatus(JSON.stringify(val))
        })
    }

    return (
        <div>
            <div style={{flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center'}}><h2>Utilities</h2></div>

            <div>
                <Typography>DNS List</Typography>
                <TextField variant="standard" name="bib" id="biblist" label="Comma Separated Bib List" style={{width: 400}}/><br/>
                <Button variant="contained" sx={{width: 40, marginTop: 4}} onClick={() => {submitDNS(document.getElementById('biblist').value)}}>Submit</Button>
                <Typography variant="caption" align="right">{status}</Typography>
            </div>
            <br/><br/>
            <div>
            <a href={"https://tbf.my-races.com/sdr?raw"}>Audit Page</a>  
            </div>
            <br/><br/>
            
            <div style={{marginBottom: 10}}>
                <Typography>Mike's Web Reports</Typography>
                <div>
                {races.map((race) => (
                    <li>
                    <a href={"https://tbf.my-races.com/sdr?rid=" + race.id + "&xls"}>{race['name']}</a>  
                    </li>
                ))}
                </div>
            </div>

            <div style={{marginBottom: 10}}>
                <Typography>USAT Reports</Typography>
                <div>
                {races.map((race) => (
                    <li>
                    <a href={"https://tbf.my-races.com/sdr?rid=" + race.id + "&usat"}>{race['name']}</a>  
                    </li>
                ))}
                </div>
            </div>

            <div style={{marginBottom: 10}}>
                <Typography>Bib Order List</Typography>
                <div>
                {races.map((race) => (
                    <li>
                    <a href={"https://tbf.my-races.com/sdr?rid=" + race.id + "&bib"}>{race['name']}</a>  
                    </li>
                ))}
                </div>
            </div>

        </div>

        


    );
};

export default Utilities;
